import React, {useCallback, useState} from 'react';
import {Button, Modal, Typography} from 'antd';
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import {LoginViewStore} from "../view-store";
import {Api} from "../api/api";


export const loginModalsTranslations = {
    "en": {
        "forgotPassword": "Forgot password?",
        "shouldSend": "Should I send a password reset link to your email",
        "sendIt": "Yes, send it",
        "cancel": "Cancel",
        "requesting": "Requesting for reset password link",
        "serverError": "Server Error: ",
        "restorePassword": "Restore password link sent to your email",
        "errorSending": "Error sending restore password link",
        "ok": "Ok",
        "sorry": "Sorry, you member does not have an email. ",
        "contact": "Please, contact support on click to ",
        "link": "this link"
    },
    "fi": {
        "forgotPassword": "Unohtunut salasana?",
        "shouldSend": "Lähetetäänkö salasanan nollauslinkki sähköpostiisi",
        "sendIt": "Kyllä, lähetä",
        "serverError": "Serverivirhe: ",
        "cancel": "Peruuta",
        "requesting": "Pyydetään salasanan nollauslinkkiä",
        "restorePassword": "Salasanan nollauslinkki lähetetty",
        "errorSending": "Virhe palautuslinkin lähetyksessä",
        "ok": "Ok",
        "sorry": "Anteeksi, jäsennumerollasi ei ole sähköpostia. ",
        "contact": "Ota yhteyttä tukeen klikkaamalla ",
        "link": "tätä linkkiä"
    }
}


const useConfirmSent = () => {
    const appEmail = LoginViewStore.useState(s => s.email);
    const member = LoginViewStore.useState(s => s.member);
    const {t} = useTranslation(['loginModals']);
    return useCallback((email, memberId) => {
        Modal.confirm({
            title: t('forgotPassword'),
            content: <Typography.Paragraph style={{display: "inline"}}>{t('shouldSend')} <Typography.Title
                level={5}>{email || appEmail}?</Typography.Title></Typography.Paragraph>,
            okText: t('sendIt'),
            cancelText: t('cancel'),
            async onOk() {
                const id = toast.loading(t('requesting'));
                await Api.sendResetPasswordLink({
                    email: appEmail,
                    member: member || memberId,
                }).then(({
                             error, ok
                         }) => {
                    if (error) {
                        toast.error(`${t('serverError')} ${error}`);

                    } else if (ok) {
                        toast(t('restorePassword'));
                    } else {
                        toast.error(t('errorSending'));
                    }
                });

                toast.dismiss(id);
            },
            onCancel() {
                //console.log('Cancel');
            },
        });
    }, [appEmail, member])
};


const useConfirmWithoutEmail = () => {
    const {t} = useTranslation(['loginModals']);
    return () => {
        Modal.confirm({
            title: t('forgotPassword'),
            content: <>
                <Typography.Paragraph>{t('sorry')} </Typography.Paragraph>
                <Typography.Paragraph>{t('contact')} <a
                    href={'https://www.suomengolfseniorit.fi/yhteystiedot'}
                    target={"__blank"}>{t('link')}</a></Typography.Paragraph>
            </>,
            okText: t('ok'),
            okButtonProps: {disabled: true},
            cancelText: t('cancel'),
            onCancel() {
                //console.log('Cancel');
            },
        });
    }
}

export const ForgotPasswordModalConfirm = () => {
    const {t} = useTranslation(['login']);
    const email = LoginViewStore.useState(s => s.email);
    const member = LoginViewStore.useState(s => s.member);
    const sent = useConfirmSent();
    const sentWithoutEmail = useConfirmWithoutEmail();
    const [loading, setLoading] = useState(false);

    const onClick = async () => {
        if (loading) return;
        if (email) {
            setLoading(true);
            await Api.emailHasMultipleMembers(email).then(({users}) => {
                if (users) {
                    LoginViewStore.update(s => {
                        s.users = users;
                        s.selectUsers = true;
                        s.selectUsersAction = member => sent(email, member);
                    });
                }else{
                    sent();
                }
            });

            setLoading(false);

        } else {
            setLoading(true);
            await Api.memberHasEmail(member)
                .then(async ({hasEmail, secureEmail}) => {

                    if (hasEmail) {
                        await LoginViewStore.update(s => {
                            s.secureEmail = secureEmail;
                        });
                        sent(secureEmail);
                    } else {
                        sentWithoutEmail();
                    }
                });

            setLoading(false);
        }
    }

    return (
        <>
            <Button type="link" loading={loading} onClick={onClick}>
                {t('forgotPassword')}
            </Button>
            <Modal/>
        </>
    );
};
